<template>
  <div class="wrap">
    <div class="top">
      <img src="@assets/imgs/ebike/0M.png" class="topbg" />
      <div class="toplogo" v-if="false">
        <img src="@assets/imgs/ebike/GOWOW Logo hei.png" />
        <br />
        <span v-if="!isCN"> Electric Dirt Bike</span>
        <ul class="title" v-if="isCN">
          <li>格</li>
          <li>物</li>
          <li>电</li>
          <li>动</li>
          <li>摩</li>
          <li>托</li>
          <li>车</li>
        </ul>
      </div>
    </div>
    <ul class="text" ref="textw">
      <li>{{ $t("ebike.你好！我们是格物电动摩托车") }}</li>
      <li>
        {{ $t("ebike.“敢于颠覆传统，改善交通与环境，让人们享受出行”，") }}
      </li>
      <li>
        {{ $t("ebike.是格物电动摩托车的使命，") }}
      </li>
      <li>
        {{ $t("ebike.我们致力于为骑行者打造更安全、更便捷、") }}
      </li>
      <li>
        {{ $t("ebike.更有趣的智能电动摩托车。") }}
      </li>
      <li>
        {{ $t("ebike.我们坚持核心硬件自研，") }}
      </li>
      <li>
        {{ $t("ebike.并在电机、电控、电池芯、") }}
      </li>
      <li>
        {{ $t("ebike.前后避震、智能操作模式") }}
      </li>
      <li>
        {{ $t("ebike.等关键技术领域取得了技术自研成果，") }}
      </li>
      <li>
        {{ $t("ebike.我们坚持自建制造基地为唯一的生产模式，") }}
      </li>
      <li>
        {{ $t("ebike.并在自建供应链体系，保障核心零部件的供应。") }}
      </li>
    </ul>
    <div class="center">
      <p class="table">{{ $t("ebike.核心技术自研") }}</p>
      <ul>
        <li>
          <p>01.{{ $t("ebike.驱动系统") }}</p>
          <img src="@assets/imgs/ebike/4.png" />
        </li>
        <li>
          <p>02.{{ $t("slides.电机") }}</p>
          <img src="@assets/imgs/ebike/5.png" />
        </li>
        <li>
          <p>03.{{ $t("slides.电控") }}</p>
          <img src="@assets/imgs/ebike/6.png" />
        </li>
      </ul>
      <ul>
        <li>
          <p>04.{{ $t("slides.前避震") }}</p>
          <img src="@assets/imgs/ebike/1.png" />
        </li>
        <li>
          <p>05.{{ $t("slides.后避震") }}</p>
          <img src="@assets/imgs/ebike/2.png" />
        </li>
      </ul>
    </div>
    <div class="bottom">
      <img src="@assets/imgs/ebike/starry skyM.png" />
      <ul>
        <li class="lable">{{ $t("ebike.设计能力") }}</li>
        <li>{{ $t("ebike.未来时尚设计") }}</li>
        <li>
          {{ $t("ebike.年轻时尚的设计团队，打造未来感十足的电动摩托车") }}
        </li>
        <li v-if="isCN">电动摩托车</li>
        <li>
          {{
            $t(
              "ebike.“银河”家族设计语言造型设计，并将设计语言定义为未来时尚设计"
            )
          }}
        </li>
        <li>
          {{ $t("ebike.星辰，指引探索者们方向，赋予人们无垠的想象") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      textw: "50vw",
    };
  },
  mounted() {},
  computed: {
    ...mapState(["lang"]),
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
@import "~@assets/styles/func.scss";
img {
  vertical-align: top;
}
.wrap {
  position: relative;
  overflow: hidden;
  .top {
    position: relative;
    width: 100vw;
    height: auto;
    .topbg {
      width: 100vw;
    }
    .toplogo {
      width: 100vw;
      top: 25%;
      position: absolute;
      text-align: center;
      img {
        width: 55vw;
        margin: 0;
        padding: 0;
      }
      span {
        font-size: px2rem(24px);
        font-weight: 400;
        font-family: PingFang-SC-Medium;
        // font-style: italic;
      }
      .title {
        width: 55vw;
        display: flex;
        justify-content: space-evenly;
        position: relative;
        bottom: px2rem(8px);
        margin: 0 auto;
        list-style: none;
        font-size: px2rem(20px);
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
      }
    }
  }
  .text {
    width: 80vw;
    margin: px2rem(15px) auto;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 300;
    line-height: px2rem(30px);
    font-size: px2rem(14px);
    // li {
    //   margin: px2rem(14px) 0;
    // }
  }
  .center {
    width: 100vw;
    height: auto;
    background-color: #fafafa;
    padding: 3vw 0 1vw 0;
    .table {
      text-align: center;
      font-size: px2rem(24px);
      font-family: PingFang SC;
      font-weight: 700;
      margin-top: px2rem(20px);
    }
    ul {
      li {
        width: 85vw;
        margin: px2rem(20px) auto;
        img {
          width: 100%;
        }
        p {
          font-size: px2rem(20px);
          font-family: PingFang SC;
          line-height: px2rem(40px);
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
  .bottom {
    width: 100vw;
    position: relative;
    height: auto;
    ul {
      position: absolute;
      top: 8%;
      color: white;
      width: 100vw;
      text-align: center;
      height: auto;
      li {
        width: 85vw;
        font-size: px2rem(14px);
        margin: 0 auto;
        font-family: PingFang SC;
        font-weight: 300;
        line-height: px2rem(36px);
      }
      .lable {
        font-size: px2rem(35px);
        font-family: PingFang SC;
        font-weight: 300;
        line-height: px2rem(120px);
      }
    }
    img {
      width: 100vw;
      vertical-align: top;
    }
  }
}
</style>
